module.exports = __webpack_public_path__ + "media/images/icons/icon-product_5-71869abf0f3ffd65b5bff2d3cb106fbf.svg";